import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchAppointments = createAsyncThunk('appointments/fetchAppointments' , async(_, thunkAPI) =>{
    try{
        const token = localStorage.getItem('token');
        const res = await axios.get('https://api.thevisaman.in/api/appointments/all',
            {
                headers:{
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return res.data.data;
    }catch(error){
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

const appointmentSlice = createSlice({
    name : 'appointments',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchAppointments.pending, (state)=>{
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchAppointments.fulfilled,(state, action) =>{
            state.loading = false;
            state.data = action.payload;
        })
        .addCase(fetchAppointments.rejected, (state,action) =>{
            state.loading = false;
            state.error = action.payload.message || 'Failed to fetch appointments';
        });
    },
});

export default appointmentSlice.reducer;